var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShare2 = function SvgShare2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.455 2.309a3.327 3.327 0 1 1-2.525 5.492L9.675 10.87a3.32 3.32 0 0 1 0 2.26l5.257 3.065a3.328 3.328 0 1 1-.607 1.034l-5.256-3.063a3.327 3.327 0 1 1-.001-4.333l5.257-3.067a3.327 3.327 0 0 1 3.13-4.456m0 13.927c-.76 0-1.425.399-1.802.998q-.01.03-.025.058-.023.036-.05.067a2.128 2.128 0 1 0 1.877-1.123M6.545 9.87a2.129 2.129 0 0 0 0 4.255 2.127 2.127 0 0 0 0-4.254m10.91-6.363a2.128 2.128 0 1 0 0 4.257 2.128 2.128 0 0 0 0-4.257"
  })));
};
export default SvgShare2;